import React from "react";
import { Helmet } from "react-helmet";
import AccelerateSection from "./components/AccelerateSection";
import BusinessFaqSection from "./components/BusinessFaqSection";
import BusinessHeaderSection from "./components/BusinessHeaderSection";
import BusinessJourneySection from "./components/BusinessJourneySection";
import BusinessLogoStripSection from "./components/BusinessLogoStripSection";
import DeliveryApproachSection from "./components/DeliveryApproachSection";
import DigitalCompetencies from "./components/DigitalCompetencies";
import PartnershipProcessSection from "./components/PartnershipProcessSection";
import SuccessStorySection from "./components/SuccessStorySection";
import WhyUniqueSection from "./components/WhyUniqueSection";
import SiteFooter from "../../components/layout/SiteFooter";

const Business = () => {
  return (
    <div>
      <Helmet>
        <title>Utiva | Business</title>
      </Helmet>

      <BusinessHeaderSection />

      <BusinessJourneySection />

      <BusinessLogoStripSection />

      <SuccessStorySection />

      <DigitalCompetencies />

      <PartnershipProcessSection />

      <DeliveryApproachSection />

      <WhyUniqueSection />

      <BusinessFaqSection />

      <AccelerateSection />

      <SiteFooter />
    </div>
  );
};

export default Business;
